__turbopack_context__.v({
  "controlsCenter": "tT5BjG_controlsCenter",
  "controlsLeft": "tT5BjG_controlsLeft",
  "controlsRight": "tT5BjG_controlsRight",
  "controlsRow": "tT5BjG_controlsRow",
  "controlsTopRow": "tT5BjG_controlsTopRow",
  "pageHeader": "tT5BjG_pageHeader",
  "title": "tT5BjG_title",
  "titleLinkIcon": "tT5BjG_titleLinkIcon",
  "titleRow": "tT5BjG_titleRow",
  "titleWrapper": "tT5BjG_titleWrapper",
});
